/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Dispatch } from 'react';
import { refetchProjectThunk } from 'features/project/projectSlice';

type SettingsType = {
  projectId: string;
};

type SettingsDependencies = {
  dispatch: Dispatch<void>;
};

const updateSettings = (
  data: SettingsType,
  dependencies: SettingsDependencies
) => {
  const { projectId } = data;
  const { dispatch } = dependencies;
  dispatch((refetchProjectThunk as any)(projectId));
};

export default updateSettings;
